import { render, staticRenderFns } from "./Longshimmer.vue?vue&type=template&id=3fbe1d0c&"
import script from "./Longshimmer.vue?vue&type=script&lang=js&"
export * from "./Longshimmer.vue?vue&type=script&lang=js&"
import style0 from "./Longshimmer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports